// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {
	// * Break Points
	const BREAKS_POINTS = {
		XXL: 1480,
		MXL: 1380,
		XL: 1140,
		LG: 1090,
		MD: 920,
		MS: 768,
		S: 640,
		XS: 400,
	}

	$(document).ready(function () {
		// Main Nav Dropdown
		// Function at shared.js
		// $("#primary-nav li").hover(function () {
		//  	$(this).addClass("hover");
		//  	$('ul.submenu', this).fadeIn(200);
		//  }, function () {
		//  	$(this).removeClass("hover");
		//  	$('ul.submenu', this).fadeOut(200);
		// });		

		var bookbtn = document.querySelectorAll('.js-booking-cta, .header__booking-close');
		if(bookbtn.length > 0){
			bookbtn.forEach((ele)=>{
				ele.addEventListener('click', function (e) {
					e.preventDefault();
					var menuObj = document.querySelector('.header');
					menuObj.classList.toggle('open-book');
					menuObj.classList.remove('open-nav');
				});
			})
		}
		
	

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
		// $("#CheckIn").datepicker({
		// 	changeMonth: true,
		// 	dateFormat: DATE_FORMAT,
		// 	numberOfMonths: 1,
		// 	minDate: 0,
		// 	beforeShowDay: (date) => calendarRange(date),
		// 	onSelect: function (selectedDate) {
		// 		let getDate = $(this).datepicker('getDate');
		// 		let newDate = new Date(getDate.getTime());
		// 		newDate.setDate(newDate.getDate() + 3);
		// 		$("#CheckOut").datepicker("setDate", newDate);
		// 		$("#CheckOut").datepicker("option", "minDate", selectedDate);
		// 	}
		// });
		// $("#CheckOut").datepicker({
		// 	dateFormat: DATE_FORMAT,
		// 	changeMonth: true,
		// 	numberOfMonths: 1,
		// 	beforeShowDay: (date) => calendarRange(date)
		// });




		//funtionally hover video for the slider
		const EVENTS_SELECTOR$7 = '[data-tb-events="hover-video"]';
	
		const eventsHoverVideos = () => {
			const mouseVideos = document.querySelectorAll(EVENTS_SELECTOR$7)
			mouseVideos.forEach((video) => {
				if (window.screen.width > BREAKS_POINTS.LG) {
					video.addEventListener('mouseenter', () => {
						if (video.paused) {
							video.play()
						}
					});
					video.addEventListener('mouseleave', () => {
						if (!video.paused) {
							video.pause();
						}
					});
	
					video.addEventListener('ended', function () {
						this.currentTime = 0;
					});
				} else {
					video.autoplay = true;
					video.addEventListener('ended', function () {
						this.play();
					})
				}
			})
		}
		const onDOMLoaded = (callback) => {
			if (document.readyState === 'complete' || document.readyState === 'interactive') {
				document.addEventListener('DOMContentLoaded', () => {
					setTimeout(callback, 1)
				})
			} else {
				document.addEventListener('DOMContentLoaded', callback)
			}
		}
		onDOMLoaded(
			eventsHoverVideos()
		)
	});

	window.onload = function () {
		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
	};

	if( document.querySelectorAll('.js-open-modal') ) {
		let jsOpenModals = document.querySelectorAll('.js-open-modal');
		let jsContainer = document.querySelector('.js-container');
		const jsCloseButtons = document.querySelectorAll('.js-close');
	
		// Add click event listeners to open modal buttons
		jsOpenModals.forEach(button => {
			button.addEventListener('click', () => {
				jsContainer.classList.add('active');
				const modalTarget = button.getAttribute('data-target');
				const modal = document.getElementById(modalTarget);
				modal.classList.add('open');
	
			});
		});
	
		// Add click event listeners to close buttons
		jsCloseButtons.forEach(button => {
			button.addEventListener('click', () => {
				const modal = button.closest('.js-modal');
				modal.classList.remove('open');
				jsContainer.classList.remove('active');
			});
		});
	}

	//if gallery template to add tour buttons
	if(document.getElementById('filterOptions')){
		let newButtons = document.createElement('div');
		newButtons.classList.add('gallery-tour-buttons');
		newButtons.innerHTML = '<a href="https://visitingmedia.com/tt8/?ttid=the-inn-at-stonecliffe#/360?group=0&tour=2" class="popup" title="TrueTour® for the inn at stonecliffe">View in 360</a>';
		document.getElementById('filterOptions').parentNode.appendChild(newButtons,document.getElementById('filterOptions'))
	}

}());

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	 return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	}
	function offset(el) {
	var rect = el.getBoundingClientRect(),
	 scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
	 scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	 return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
	}
	//ScrollW
	function scrollW(){
	//check scroll down or up for header styles
	 let st = window.pageYOffset || document.documentElement.scrollTop;
	 let header = document.getElementById('header');
	 if(st > 80){
	if (st > lastScrollTop){
	// downscroll code
	 if(!header.classList.contains('down')){
	header.classList.add('down');
	 header.classList.remove('up');
	 }
	} else {
	// upscroll code
	 if(!header.classList.contains('up')){
	header.classList.add('up');
	 header.classList.remove('down');
	 }
	}
	} else {
	if(header.classList.contains('up') || header.classList.contains('down')){
	header.classList.remove('up');
	 header.classList.remove('down');
	 }
	}
	
	let SubMenu = document.getElementById('subMenuAnchor');
	 if(SubMenu){
	let subPost = document.getElementById('subMenu');
	 let subPosition = '';
	 if(document.body.classList.contains('alert_open')){
	subPosition = offset(SubMenu).top - 147;
	 } else {
	subPosition = offset(SubMenu).top - 78;
	 }
	if(st > subPosition){
	if(!subPost.classList.contains('floating-up')){
	subPost.classList.add('floating-up');
	 }
	} else {
	if(subPost.classList.contains('floating-up')) {
	subPost.classList.remove('floating-up');
	 }
	}
	}
	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	}
	
	
	
	
	
	

/*MOBILE MENU NAV
	****************************************************************/

//Open Navigation
$('#menu-btn').click(function (event) {
	$('html').addClass('hide-overflow');
	$('.navigation').addClass('open');
	$('.navigation').stop().animate({ left: '0px' }, { duration: 400 });
	if ($('.navigation ul li a').hasClass('.item-open')) {
		$(".item-open").get(0).scrollIntoView(false);
	}
});

$('.close-menu').click(function (event) {
	event.preventDefault();
	$('html').removeClass('hide-overflow');
	$('.navigation').removeClass('open');
	$('.navigation').stop().animate({ left: '-100%' }, { queue: false, duration: 300 });
});

//SUBNAVIGATION

// Open active sub-nav on load
$('.navigation ul.submenu li .active').closest('.inner').addClass('open')
$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, function () { }).addClass('menu-open');

//Toggle open/close on tap
$('.navigation li a').off('click').on('click', function (event) {
	if ($(this).parent().children(".sub-sub-menu").length > 0) {

		event.preventDefault();

		if ($(this).next().hasClass('menu-open')) {
			$(this).closest('.inner').removeClass('open');
			$('.navigation ul li').removeClass('item-open');
			$(this).parent().addClass('item-open');
			$(this).next().slideUp(300, function () {
				if ($('.navigation ul li a').hasClass('active')) {
					$(".item-open").get(0).scrollIntoView(false);
				}
			}).removeClass('menu-open');
		} else {
			$(this).closest('.inner').addClass('open');
			$('.navigation ul li').removeClass('item-open');
			$(this).parent().addClass('item-open');
			$('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open');
			$(this).next().addClass('menu-open').slideDown(300, function () {
				if ($('.navigation ul li a').hasClass('active')) {
					$(".item-open").get(0).scrollIntoView(false);
				}
			});
		}
	}
});